import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const cancelOrderItemMutation =  gql`mutation cancel_order_item($cancelOrderItem: CancelOrderItemInput!){
  cancel_order_item(details:$cancelOrderItem){
    status
  }
}`
@Injectable({
  providedIn: 'root'
})
export class CancelOrderItemService {

  constructor(
    private apollo: Apollo
  ) { }

  cancelOrderItem(cancelOrderItem: any){
    return this.apollo.use('external').mutate({
      mutation: cancelOrderItemMutation,
      variables:{
        cancelOrderItem
      }
    }).toPromise();
  }
}
